/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycGeographicRiskAnalysisDto } from '../../models/kyc-geographic-risk-analysis-dto';

export interface GetGeographicRiskAnalysis$Params {
  processId: string;
}

export function getGeographicRiskAnalysis(http: HttpClient, rootUrl: string, params: GetGeographicRiskAnalysis$Params, context?: HttpContext): Observable<StrictHttpResponse<KycGeographicRiskAnalysisDto>> {
  const rb = new RequestBuilder(rootUrl, getGeographicRiskAnalysis.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycGeographicRiskAnalysisDto>;
    })
  );
}

getGeographicRiskAnalysis.PATH = '/kyc/processes/{processId}/geographic-risk-analysis';
